__webpack_require__.p = "https://sandbox-ecommerce.vialaser.com.br/";